// @TODO <HEALTH2019>
App.controller('HealthInsuranceDetailsCtrl', ['$scope', '$sce', '$state', '$http', '$mdDialog', 'Config', '$stateParams', 'insuranceService', 'statesService', '$filter', 'profileService', '$timeout', 'dataUser', 'Blob', 'FileSaver', '$rootScope', 'healthInsuranceService', function ($scope, $sce, $state, $http, $mdDialog, Config, $stateParams, insuranceService, statesService, $filter, profileService, $timeout, dataUser, Blob, FileSaver, $rootScope, healthInsuranceService) {
// @TODO </HEALTH2019>
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsurance';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Moja deklaracja (dane)';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.home.healthInsurance.list';
    $scope.$emit('link', $scope.link);

    $scope.data = $scope.stateParams.package;
    if (!$scope.data) {
        $state.go('root.home.healthInsurance.list');
    }


    if ($scope.data.partner && Object.keys($scope.data.partner).length) {
        $scope.partner_length = true;
    }

    if ($scope.data.children.length) {
        $scope.children_length = true;
    }

    $scope.getDeclaration = function(ev, value) {
        var el = $(ev.currentTarget);
        if (el.hasClass('disabled')) {
            return 0;
        } else {
            $(ev.currentTarget).addClass('disabled');
        }
        var id = value.uuid, barcode = value.barcode || '';
// @TODO <HEALTH2019>
            healthInsuranceService.getDeclaration(id).then(function (data) {
                if (data.status === 200) {
                    var data = new Blob([data.data], {type: 'application/pdf'});
                    FileSaver.saveAs(data, 'Deklaracja_' + barcode + '.pdf');
                }

                $timeout(function () {
                    $(ev.currentTarget).removeClass('disabled');
                }, 1500);
            });

// @TODO </HEALTH2019>


    }
}]);
